import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import UploadFileInstitution from "../../../../components/uploadFile/uploadFileInstitution";
import HeaderScreenPresval from "../../../../components/headerScreenPresval";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const AvailableDetailView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Valores Disponibles PTM \ Disponible Detalle"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchEmisora}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <SubtitleLabel header="Emisora" isBold={true}/>
                                    <InputText name="emisoraToSearch"
                                               maxLength={20}
                                               onChange={props.onChangeTextFilter}
                                               value={props.emisoraToSearch}/>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Contraer / Expandir Grupos" className="p-button-secondary"
                                    onClick={props.expandReduceAll}
                            />&nbsp;
                            <UploadFileInstitution type={["text/csv", "application/vnd.ms-excel"]}
                                                   size="1000"
                                                   urlAction="/appapv/uploadFileAvailableFid.action"
                                                   className="p-button-secondary"
                                                   titleHeader="Operación \ Valores Disponibles PTM \ Disponible Detalle \ Cargar Archivo"
                                                   titleButton="Cargar disponibilidad"
                                                   errorTypeMessage="El documento debe ser csv."
                                                   errorSizeMessage="El archivo es muy pesado."
                                                   instructions="Debe ser un archivo de texto con comas de separación entre los datos."
                                                   action={props.searchEmisora}
                                                   rol={"2"}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            expandedRows={props.expandedRows}
                            onRowToggle={props.handleToggle}
                            value={props.dataAvailableDetail}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column expander={true} style={{width: '3em'}}/>
                            <Column field="emision" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default AvailableDetailView;